import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApiClientService, ToastService } from '@services/index';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, take } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'app-send-agreement-email-modal',
    templateUrl: './send-agreement-email-modal.component.html',
    styleUrl: './send-agreement-email-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SendAgreementEmailModalComponent {
    private readonly modal = inject(NgbActiveModal);
    private readonly translateService = inject(TranslateService);
    private readonly toastService = inject(ToastService);
    private readonly apiClientService = inject(ApiClientService);

    public agreementIds: string[];
    public loading = false;
    public expanded = false;

    private readonly sent = new Subject<void>();
    public readonly sent$ = this.sent.asObservable();

    public toggleExpanded() {
        this.expanded = !this.expanded;
    }

    public send() {
        this.loading = true;
        this.apiClientService
            .renegotiateAgreement$({ agreementIds: this.agreementIds })
            .pipe(untilDestroyed(this), take(1))
            .subscribe({
                next: () => {
                    const title = this.translateService.instant('TOAST_TITLES.SUCCESS') as string;
                    const message = this.translateService.instant(
                        'TOAST_MESSAGES.RENEGOTIATE_AGREEMENT_SUCCESS'
                    ) as string;
                    this.toastService.open(title, message, { type: 'success' });
                    this.sent.next();
                    this.closeModal();
                },
                error: () => {
                    this.loading = false;
                    const title = this.translateService.instant('TOAST_TITLES.ERROR') as string;
                    const message = this.translateService.instant(
                        'TOAST_MESSAGES.RENEGOTIATE_AGREEMENT_ERROR'
                    ) as string;
                    this.toastService.open(title, message, { type: 'error', progressBar: true });
                }
            });
    }

    public closeModal() {
        this.modal.close();
    }
}
